module.exports = __webpack_public_path__ + "img/mc_logo_claro.0d1e4929.png";